module.exports = __webpack_public_path__ + "static/media/Developmenticon04@3x.dcc47ece.png";